import { Stack, Label, PrimaryButton, DetailsList } from '@fluentui/react';
import React from 'react';

export interface IConnectsProps {
    apiUrl: string;
    username: string;
    token: string;
    site: string;
}

export interface IConnectsState {
    connects: TConnect[];
    ipDetails: string;
    longtime: boolean;
    selectedIP?: string;
};

class TConnect {
    date: string;
    ip: string;
    id: number;
    country?: string;
    city?: string;
}
  

export default class Connects extends React.Component<IConnectsProps, IConnectsState> {
    constructor(props: IConnectsProps) {
        super(props);
        this.state = {
            connects: [],
            ipDetails: "",
            longtime: true 
        }
        this.GetConnects();
        setTimeout(() => {
            this.filter24hours();
        }, 1000);
    }

    GetConnects() {
        fetch(`${this.props.apiUrl}/Connects?username=${this.props.username}&token=${this.props.token}&site=${this.props.site}`, {
            method: 'GET',
            mode: 'cors',
        }).then((response) => response.json()).then((data) => {
            let connects : TConnect[] = [];
            data.forEach(d => {
                let connect : TConnect = {
                    date : d.date.replace("T"," "),
                    ip : d.ip,
                    id : d.id,
                };
                connects.push(connect);
            });

            console.log({connects});
            
            connects.sort((a,b) => a.date < b.date ? 1 : -1);
            this.setState({connects: connects, longtime: true});
        });
    }

    filter24hours(){
        let nd = new Date();
        nd.setDate(nd.getDate() - 1);
        const connects = this.state.connects.filter(connect => {
            let cd = new Date(connect.date);
            return cd > nd;
        });
        this.setState({connects: connects, longtime: false});
    }

    public render(): React.ReactElement<IConnectsProps> {
        return (  
            <div>
                <PrimaryButton disabled={this.state.longtime} text="Laatse 7 dagen" onClick={()=>{this.GetConnects()}} />
                &nbsp;
                <PrimaryButton disabled={!this.state.longtime} text="Laatse 24 uur" onClick={()=>{this.filter24hours()}} />
                <Label>{this.state.connects.length} unieke gebruikers de laatste {this.state.longtime ? "7 dagen" : "24 uur"}</Label>
                <div>
                    {this.state.ipDetails}
                </div>
                <DetailsList
                    items={this.state.connects}
                    isHeaderVisible={true}
                    selectionPreservedOnEmptyClick={true}
                    onActiveItemChanged={(item?: any, index?: number, ev?: React.FocusEvent<HTMLElement, Element>) => { window.open(`https://whatismyipaddress.com/ip/${item.ip}`, "_blank"); }}
                />
            </div> 
            
        );
    }
}